import React, { useState } from "react";
import { FaComments, FaTimes } from "react-icons/fa";
import "../Css/commoncolor.css";

const ChatbotComponent = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      from: "bot",
      text: "👋 Hey, there! What would you like to explore?",
    },
  ]);

  // Define FAQ buttons and answers
  const faqs = [
    {
      label: "About Me",
      answer:
        "I'm a Software Engineer specializing in backend-development, AWS serverless architectures and scalable API systems.",
    },
    {
      label: "My Projects",
      answer:
        "I’ve built event-driven microservices, CQRS finance systems, API gateways with .NET and AWS Lambda, full-stack applications using React + .NET, and MVC applications.",
    },
    {
      label: "Software Design Approach",
      answer:
        "⚙️ I follow clean architecture principles, focusing on scalability, maintainability, and testability in every project.",
    },
    {
      label: "Contact Info",
      answer:
        "📩 You can reach me via the Contact page or connect with me on LinkedIn!",
    },
  ];

  // Handle user clicking a FAQ button
  const handleFaqClick = (faq) => {
    setMessages((prev) => [...prev, { from: "user", text: faq.label }]);
    setTimeout(() => {
      setMessages((prev) => [...prev, { from: "bot", text: faq.answer }]);
    }, 500); // slight delay for bot message
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: "40px", // moved slightly up
        right: "50px", // moved slightly left
        zIndex: 9999,
        transition: "all 0.3s ease",
      }}
    >
      {/* Floating Chat Button */}
      <div onClick={() => setIsOpen((prev) => !prev)} className="chat-button">
        {isOpen ? <FaTimes /> : <FaComments />}
      </div>

      {/* Chat Window */}
      {isOpen && (
        <div
          style={{
            position: "absolute",
            bottom: "80px",
            right: "0",
            width: "350px",
            maxHeight: "500px",
            borderRadius: "16px",
            background: "rgba(0, 0, 0, 0.35)",
            backdropFilter: "blur(15px)", // ✅ Add blur
            WebkitBackdropFilter: "blur(15px)",
            boxShadow: "0 0 25px rgba(241, 211, 37, 0.9)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            animation: "fadeIn 0.3s ease-in-out",
          }}
        >
          {/* Header with Mac-style dots */}
          <div
            style={{
              height: "40px",
              background: "rgba(0,0,0,0.7)",
              display: "flex",
              alignItems: "center",
              padding: "0 10px",
              gap: "8px",
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
            }}
          >
            <span
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                background: "#ff605c", // red
              }}
            />
            <span
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                background: "#ffbd44", // yellow
              }}
            />
            <span
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                background: "#00ca4e", // green
              }}
            />
          </div>
          {/* Message List */}
          <div
            style={{
              flex: 1,
              padding: "10px",
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            {messages.map((msg, idx) => (
              <div
                key={idx}
                style={{
                  alignSelf: msg.from === "bot" ? "flex-start" : "flex-end",
                  background:
                    msg.from === "bot"
                      ? "linear-gradient(135deg, #5a3e12, #b8860b, #d4af37, #ffd700)"
                      : "#222831",
                  color: msg.from === "bot" ? "#000000" : "#f7c82d",
                  padding: "8px 12px",
                  borderRadius: "12px",
                  maxWidth: "80%",
                  wordWrap: "break-word",
                  fontSize: "16px",
                }}
              >
                {msg.text}
              </div>
            ))}
          </div>

          {/* FAQ Buttons */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "5px",
              padding: "10px",
              borderTop: "1px solid rgba(241, 211, 37, 0.3)",
              background: "rgba(0, 0, 0, 0.35)",
              backdropFilter: "blur(15px)", // ✅ Add blur
              WebkitBackdropFilter: "blur(15px)",
            }}
          >
            {faqs.map((faq) => (
              <button
                key={faq.label}
                onClick={() => handleFaqClick(faq)}
                className="btn-common"
                style={{
                  flex: "1 1 45%",
                  padding: "6px 10px",
                  borderRadius: "12px",
                  border: "none",
                  backgroundColor: "transparent",
                  color: "#ffffff",
                  cursor: "pointer",
                  fontWeight: "bold",
                  boxShadow: "0 0 10px rgba(241, 211, 37, 0.6)",
                  // transition: "transform 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                {faq.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatbotComponent;
